export default __webpack_public_path__ + "static/media/bank-open.b7943292.png";